module.exports = __webpack_public_path__ + "assets/9afd0f6712b90cf778aace70a4b6544e.png";